import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { FormControl, Form, FormGroup, FormText } from "react-bootstrap";

const styles = {
  userListItem: {
    paddingTop: 8,
    paddingBottom: 8,
  },
  userSelector: {
    cursor: "pointer",
    textDecoration: "none",
  },
};

const UserSelection = ({ changeInput, loading, selectUser, users = [] }) => {
  const usersList = useMemo(
    () =>
      users.map((user) => (
        <li key={user.id} style={styles.userListItem}>
          <a
            onClick={() => selectUser(user)}
            style={styles.userSelector}
            className="user-selector"
          >
            <span style={{ fontStyle: "italic", color: "#aaa" }}>
              {user.personnelNumber}
            </span>
            &nbsp;&nbsp;{user.displayName}
          </a>
        </li>
      )),
    [users, selectUser],
  );

  return (
    <div>
      <Form>
        <FormGroup controlId="userSearchFormTitle">
          <FormControl
            style={{ width: 450 }}
            type="text"
            defaultValue=""
            placeholder="Naam medewerker"
            onChange={(e) => changeInput(e.target.value)}
            className="mb-2"
          />
          <FormText>Zoeken is niet hoofdlettergevoelig</FormText>
        </FormGroup>
      </Form>

      {(loading || usersList.length > 0) && (
        <div>
          {loading && <p>Zoeken naar medewerkers...</p>}
          {usersList.length > 0 && (
            <>
              <p>Gevonden medewerkers:</p>
              <ul style={{ listStyleType: "none", padding: 0 }}>{usersList}</ul>
            </>
          )}
        </div>
      )}
    </div>
  );
};

UserSelection.propTypes = {
  changeInput: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  selectUser: PropTypes.func.isRequired,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      personnelNumber: PropTypes.string.isRequired,
      displayName: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      resourceType: PropTypes.string.isRequired,
    }),
  ),
};

export default UserSelection;
